<div id="mi-general-details" class="mi-general-details" tabindex="-1" miFocusOnTab>
    @if (this.formisForm.fields.length > 0) {
    <div id="mi-general-details-content ">
        <div class="container">
            <div class="row justify-content-center">
                <div class="  col-12 mi-panel-wrraper  standart">
                    <div class="mi-panel-content">
                        <div class="mc-my-3">
                            <span class="mi-header">{{tabsText.generalDetails}}</span>

                        </div>

                        <div class="mi-white-panel with-shadow">
                            <div class="mi-back ">
                                <i class="pi pi-fw pi-chevron-right"></i>
                                <span (click)="back()" id="mi-general-details-back" tabindex="0" role="button"
                                    (keyup.enter)="back()">{{genericText?.back}}
                                </span>
                            </div>


                            <mc-field-form [formisForm]="formisForm">
                            </mc-field-form>

                        </div>
                    </div>
                    <div class="row justify-content-center   justify-content-md-start">
                        <div class=" mi-next blue-button col-md-3 col-12" id="mi-general-details-sent">
                            <mc-button [label]="genericText?.next + ' >'" (click)="next()"></mc-button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    }
    @else{
    <div id="mi-general-details-loaded">
        <mi-genral-skeleton></mi-genral-skeleton>
    </div>
    }


</div>